import { combineReducers } from "@reduxjs/toolkit";

import { residentDirectoryListingReducer } from "./DirectoryListing/ResidentDirectoryListingSlice";
import { pendingResidentsListingReducer } from "./PendingResidents/PendingResidentsListingSlice";

export const residentDirectoryReducer = combineReducers({
  directoryListing: residentDirectoryListingReducer,
  pendingResidentsListing: pendingResidentsListingReducer,
});
